export default {
  region: {},
  regions: []
}



// WEBPACK FOOTER //
// ./src/components/region/store/state.js